import * as signalR from '@microsoft/signalr';
import { Server } from '../enums/index.js';
import { get as getItemLocal, localStorageKey, } from '@/plugins/localStorage/index.js';

class SignalRService {
    constructor(hubUrl) {
        this.token = getItemLocal(localStorageKey.tokenKey);
        this.hubUrl = new URL(hubUrl, Server.url).toString();
        this.startPromise = null;

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.hubUrl, {
                accessTokenFactory: () => this.token
            })
            .withAutomaticReconnect()
            .configureLogging(signalR.LogLevel.Error)
            .build();
    }

    async start() {
        // If already connected, return immediately
        if (this.connection.state === signalR.HubConnectionState.Connected) {
            return;
        }

        // If already connecting, wait for that connection to complete
        if (this.startPromise) {
            return this.startPromise;
        }

        // Start new connection
        if (this.connection.state === signalR.HubConnectionState.Disconnected) {
            this.startPromise = (async () => {
                try {
                    await this.connection.start();
                } catch (err) {
                    console.error('SignalR connection error:', err);
                    throw err;
                } finally {
                    this.startPromise = null;
                }
            })();

            return this.startPromise;
        }
    }

    stop() {
        this.connection.stop();
    }

    on(event, callback) {
        this.connection.on(event, callback);
    }

    off(event, callback) {
        this.connection.off(event, callback);
    }

    async invoke(methodName, obj) {
        // Ensure connection is started before invoking
        if (this.connection.state !== signalR.HubConnectionState.Connected) {
            await this.start();
        }
        await this.connection.invoke(methodName, obj);
    }
}

export { SignalRService };
